import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import Social from "../Social/Social";
import Flashlight from "../Flashlight/Flashlight";
import HeroSection from "../../sections/Hero/Hero";

import {
  StyledContent,
  StyledMainContent,
  Side,
  MobileSocial,
} from "./Layout.styles";

const Layout = ({ children }) => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const handleExternalLinks = () => {
    const allLinks = Array.from(document.querySelectorAll("a"));
    allLinks.forEach((link) => {
      if (link.host !== window.location.host) {
        link.setAttribute("rel", "noopener noreferrer");
        link.setAttribute("target", "_blank");
      }
    });
  };

  React.useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          el.focus();
        }
      }, 0);
    }

    handleExternalLinks();
  }, [location.hash]);

  return (
    <StyledContent>
      <Flashlight>
        <HeroSection />

        <Side>
          <Social isHome={isHome} />
        </Side>

        <StyledMainContent>{children}</StyledMainContent>

        <MobileSocial>
          <Social />
        </MobileSocial>
      </Flashlight>
    </StyledContent>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
